import { Version } from '@discoverer/fuse/version/version';

export const FUSE_VERSION = new Version('14.0.0').full;
